<script setup lang="ts">
const { items } = defineProps({items: Array<{question: string, answer: string}>})
</script>

<template>
  <v-expansion-panels class="mb-6">
    <v-expansion-panel v-for="item in items">
      <v-expansion-panel-title expand-icon="mdi-menu-down">
        {{ item.question }}
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        {{ item.answer }}
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<style scoped>

</style>
